<template lang="pug">
  v-container
    illustration-state(
      :illustration="illustration"
      title="Saisissez votre code"
      :body="body")
    v-row
      v-col(:cols="12")
        input-otp(
          v-model="otp"
          @change="resetError"
          :error="error")
      v-col.text-center(:cols="12")
        v-fade-transition(v-if="loading")
          v-progress-circular(
            color="primary"
            indeterminate)
</template>

<script>
import IllustrationState from '@iez/components/illustration-state/'
import InputOtp from '@iez/components/inputs/otp/'
import illustration from '@iez/illustrations/Authentication/'
import { reactive, toRefs, onMounted, watch, ref, computed } from '@vue/composition-api'
import router from '@iez/core/router/'
import { page, injectRouteState } from '@iez/core'
import { noop } from 'lodash'
import user from '@iez/lib/user/'
import waitFor from '@iez/lib/wait-for/'
import { state as commonState } from '../../'
import initNativeCallback from '@iez/lib/init-native-callback/'

export const route = {
  name: 'Authentication-Otp',
  path: '/authentication/otp'
}

export default {
  ...route,

  components: {
    InputOtp,
    IllustrationState
  },

  props: {
    step: Number,
    isNewUser: Boolean
  },

  setup (props, { emit }) {
    const AuthenticationPhone = injectRouteState({
      name: 'Authentication-PhoneNumber'
    })

    const state = reactive({
      otp: ``,
      loading: false,
      phoneNumber: AuthenticationPhone.phoneNumber,
      error: ``,
      body: computed(
        () => props.isNewUser
          ? commonState.registerMessage ?? `Inscrivez-vous avec le code reçu par sms au ${state.phoneNumber}. En vous inscrivant, vous acceptez nos conditions générales d'utilisation ainsi que notre politique de confidentialité.`
          : `Identifiez vous avec le code par sms au ${state.phoneNumber}.`
      )
    })

    const topBar = page.topBar.set({
      title: 'Authentification',
      route,
      steps: {
        current: 2,
        count: 2
      }
    })

    /* page.topHeader.set({
      value: 'Connexion'
    })
 */
    const handleError = () => {
      if (!state.error) {
        state.error = `Code invalide. Êtes-vous sûr d'avoir saisi le bon code ?`
        state.otp = ``
        state.loading = false
      }
    }

    const resetError = () => {
      state.error = ``
    }

    const {
      callback: nativeConfirmCode
    } = initNativeCallback({
      name: `confirmCode`
    })

    watch(
      () => state.otp,
      async () => {
        if (state.otp) {
          state.loading = true
          resetError()
          const result = (
            window.ReactNativeWebView
              ? await nativeConfirmCode({ otp: state.otp })
              : await AuthenticationPhone.confirmationResult.confirm(state.otp)
          ).catch(console.error)
          if (!result) {
            handleError()
          } else {
            user.isNewUser = result.additionalUserInfo.isNewUser
          }
        }
      }, {
        immediate: true
      }
    )

    return {
      ...toRefs(state),
      illustration,
      resetError
    }
  }
}
</script>
